import React from "react";
import { Link } from "react-router-dom";

interface IProps {
    view?: string;
    callback?: any;
    cadenceText?: any;
    hasCombinationService?: boolean;
}

const CreditReportNavigation: React.FunctionComponent<IProps> = function (props) {
    const getLinkText = () => {
        let text = "";
        if (props.hasCombinationService) {
            text = props.view === "daily" ? "View Three Bureau " + props.cadenceText() + " Report" : props.view === "3b" ? "View Daily Report" : "";
        }
        return text;
    };

    return (
        <React.Fragment>
            <div role={getLinkText() ? "link" : null} onClick={() => props.callback()} onKeyPress={() => props.callback()}>
                {getLinkText() ? (
                    <Link to="#" className="default_link">
                        <span className="nav-text">{getLinkText()}</span>
                    </Link>
                ): null}
            </div>
        </React.Fragment>
    );
};

export default CreditReportNavigation;
